import React from 'react';
import './LoadingPartial.css';

const LoadingPartial = ( { isLoading } ) => (
    <div className="loadingPartial">&nbsp;</div>
)
export default LoadingPartial;


/** WEBPACK FOOTER **
 ** ./src/components/LoadingPartial/index.js
 **/